import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// definitons
import auth from './modules/architecture/auth'
import settings from './modules/architecture/settings'
import layout from './modules/architecture/layout'
import definitions from './modules/architecture/definitions'
import categories from './modules/category'
import invoiceAddress from './modules/invoiceAddress'

// superadmin
import company from './modules/system/company'
import packages from './modules/system/packages'
import user from './modules/system/user'
import superProduct from './modules/super-product'

// project modules
import current from './modules/current/current'
import proposal from './modules/current/proposal'
import employee from './modules/current/employee'
import appointment from './modules/appointment'
import service from './modules/service'
import client from './modules/client'
import sms from './modules/sms'
import coiffeurappointment from "./modules/coiffeurappointment";
import announce from "./modules/announce";
import report from "./modules/report";
import newservice from "./modules/newservice"
import clientproducs from './modules/clientproducts'



export default new Vuex.Store({
  modules: {
    auth,
    settings,
    layout,
    definitions,
    categories,
    invoiceAddress,
    announce,
    report,


    // superadmin
    company,
    user,
    packages,
    superProduct,
    coiffeurappointment,

    // modules
    current,
    appointment,
    service,
    client,
    proposal,
    employee,
    sms,
    newservice,
    clientproducs
  }
});
